export function handleCarousel() {
  const carousel = document.querySelector('.something_specific__wrapper');

  if (carousel) {
    const list = carousel.querySelector('.something_specific__list');

    list.addEventListener('scrollend', () => {
      const current = Math.round(
        (list.scrollLeft / (list.scrollWidth - list.clientWidth)) * 5,
      );
      const bullets = carousel.querySelectorAll('.something_specific__bullet');

      Array.from(bullets).forEach((bullet, index) => {
        bullet.classList.remove('current');
        if (index === current) {
          bullet.classList.toggle('current');
        }
      });
    });
  }
}

export default handleCarousel;
